"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlatFormButton = exports.FormButton = void 0;
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const index_1 = require("./../index");
const FormButton = (props) => {
    return (react_1.default.createElement(index_1.Flex, { justify: "flex-end", align: "center", noGrow: true },
        react_1.default.createElement(index_1.FlexSpace, null),
        react_1.default.createElement(index_1.Button, { type: "button", kind: props.kind, "aria-label": props.label, disabled: props.disabled, onClick: props.onClick }, props.children || props.label)));
};
exports.FormButton = FormButton;
const FlatFormButton = (props) => {
    return (react_1.default.createElement(index_1.Flex, { justify: "flex-end", align: "center", noGrow: true },
        react_1.default.createElement(index_1.FlatButton, { type: "button", "aria-label": props.label, disabled: props.disabled, onClick: props.onClick }, props.children || props.label)));
};
exports.FlatFormButton = FlatFormButton;
//# sourceMappingURL=Button.js.map